import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Language } from 'src/app/api/invoice/models';

@Component({
  selector: 'app-sales-order-confirmation',
  templateUrl: './sales-order-confirmation.component.html',
  styleUrls: ['./sales-order-confirmation.component.scss'],
})
export class SalesOrderConfirmationComponent {
  isDeadHead: boolean;
  isChecked: boolean;
  isLayoverTime: boolean;
  isWaitingTime: boolean;
  language = Language;
  formData: {
    language: Language;
    isDeadHead: boolean;
    isChecked: boolean;
    isLayoverTime: boolean;
    isWaitingTime: boolean;
  } = {
    language: Language.English,
    isDeadHead: false,
    isChecked: true,
    isLayoverTime: false,
    isWaitingTime: false,
  };
  languages: { value: string; label: string }[] = [];
  constructor(
    public dialogRef: MatDialogRef<SalesOrderConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      callbackMethod: (form: any) => void;
      type: string;
    }
  ) {
    this.isDeadHead = false;
    this.isChecked = true;
    this.isLayoverTime = false;
    this.isWaitingTime = false;
  }

  onCancelClick(): void {
    this.dialogRef.close({ success: 'false' });
  }

  onSubmit() {
    // Handle form submission logic here
    if (this.data && this.data.callbackMethod) {
      this.data.callbackMethod(this.formData);
      this.dialogRef.close({ success: 'true' });
    }
  }
}
